var generic = generic || {};
var site = site || {};

(function ($) {
  site.emailSignupCustom = {
    initEmailSignup: function ($template) {
      var $emailForm = $template.is('form') ? $template : $('form', $template);
      var $smsContent = $('.email-signup-custom__sms-content', $template);
      var $mobileNumberInput = $('input[type="tel"][data-is-sms-signup="1"]', $template);
      var $termsAndConditions = $('.js-terms-conditions', $template);
      var $gdprCheck = $('.js-gdpr-check', $template);
      var $signupButton = $('.js-email-signup-custom-cta .button', $template);
      var $errorMessages = $('ul.error_messages', $template);

      // Show terms + conditions
      $mobileNumberInput.on('focus', function () {
        $termsAndConditions.slideDown(300);
      });

      // hide terms + conditions when clicked outside
      $(document).on('click', function (hideEvt) {
        if (!$(hideEvt.target).closest($emailForm).length && !$(hideEvt.target).is($emailForm)) {
          if ($termsAndConditions.is(':visible') && $mobileNumberInput.val() === '') {
            $termsAndConditions.slideUp(300);
          }
        }
      });

      $gdprCheck.on('change', function () {
        $signupButton.toggleClass('button--disabled', !this.checked).prop('disabled', !this.checked);
      });

      $emailForm.on('submit', function (submitEvt) {
        submitEvt.preventDefault();

        // Transform string into array of form elements
        var params = {};

        $.each($emailForm.serializeArray(), function (index, kv) {
          params[kv.name] = kv.value.replace('undefined', '').replace('%40', '@');
        });

        // handle the sms_promotions checkbox - if its checked its being read as 'on' when serialized
        // we need a boolean value
        if ($smsContent.find('input[name="SMS_PROMOTIONS"]').prop('checked')) {
          params.SMS_PROMOTIONS = 1;
        }

        // Send the data via a json rpc call
        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: [params],
          onSuccess: function (result) {
            $template.attr('form-status', 'success');
          },
          onFailure: function (result) {
            var errorObjectsArray = result.getMessages();

            $template.attr('form-status', 'error');
            generic.showErrors(errorObjectsArray, $errorMessages, null);
          }
        });
      });
    }
  };

  Drupal.behaviors.emailSignupFormCustomV1 = {
    attach: function (context) {
      var $templates = $('.js-email-signup-custom', context);

      $templates.each(function (i, obj) {
        var $template = $(obj);

        site.emailSignupCustom.initEmailSignup($template);
      });
    }
  };
})(jQuery);
